import script from "./Widget.vue?vue&type=script&setup=true&lang=ts"
export * from "./Widget.vue?vue&type=script&setup=true&lang=ts"

import "./Widget.vue?vue&type=style&index=0&id=600e1451&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600e1451"]])

export default __exports__